// extracted by mini-css-extract-plugin
export var actionButton = "_7y-1";
export var actionButtons = "_7y-2";
export var actions = "_7y-0";
export var aiUnread = "_7y-10";
export var alignCenter = "_7y-h";
export var backWrapper = "_7y-3";
export var cellContainer = "_7y-4";
export var checkboxContainer = "_7y-5";
export var contentContainer = "_7y-6";
export var contentHeader = "_7y-8";
export var conversationsTableWrapper = "_7y-s";
export var draftReplyBadgeContainer = "_7y-m";
export var dropdownItem = "_7y-b";
export var dropdownItemsContainer = "_7y-a";
export var dropdownTitle = "_7y-c";
export var errorIcon = "_7y-7";
export var filter = "_7y-d";
export var gray = "_7y-i";
export var headerActionButtons = "_7y-e";
export var headerCheckboxContainer = "_7y-f";
export var icon = "_7y-j";
export var menuContainer = "_7y-k";
export var noMoreTicketsIcon = "_7y-12";
export var noMoreTicketsSubText = "_7y-13";
export var oneLine = "_7y-l";
export var optionsButton = "_7y-n";
export var plus = "_7y-o";
export var portalButtonsWrapper = "_7y-g";
export var red = "_7y-p";
export var scrolledTop = "_7y-9";
export var search = "_7y-q";
export var selectedConversationsCount = "_7y-r";
export var spinner = "_7y-t";
export var strong = "_7y-u";
export var summaryCell = "_7y-v";
export var tableContainer = "_7y-11";
export var tagContainer = "_7y-w";
export var threeDots = "_7y-x";
export var twoLines = "_7y-y";
export var unread = "_7y-z";